import { EnvVars } from "./types";

declare global {
    interface Window {
        env: any
    }
}

export const env: EnvVars = { ...process.env, ...window.env }